// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__f322R","label":"Category_label__1NZXH","content":"Category_content__3TYLk","header":"Category_header__1riK7","location":"Category_location__327Jp"};